import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import '@/shared/ui/tokens.css';
import { Providers } from '@/app/providers';
import { router } from '@/app/router';
import { AppConfigCtx, loadConfig } from '@/app/config';

async function bootstrap() {
  const config = await loadConfig();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppConfigCtx.Provider value={config}>
        <Providers>
          <RouterProvider router={router} />
        </Providers>
      </AppConfigCtx.Provider>
    </StrictMode>,
  );
}

void bootstrap();
